<template>
  <div class="afm-star-container">
    <div class="star-img-container">
      <img v-for="(item,index) in getStarIndex(rating)" :data-index="index" :key="index" class="star-img" :src="item" alt="">
      <p class="star-text">{{rating}}</p>
    </div>
  </div>
</template>

<script>
import star2 from "../../assets/img/star2.jpg";
import star1 from "../../assets/img/star1.jpg";
import star0 from "../../assets/img/star0.jpg";

export default {
  name: "afm-star",
  props: {
    rating: {
      type: String | Number,
      default: () => 0
    },
    isOneStar: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getStarIndex(rating) {
      let temp = [];
      if (this.isOneStar) {
        temp.push(star0)
        return temp
      }

      if (rating || rating === 0) {
        for (let i=1; i<6; i++) {
          if (rating >= i) {
            temp.push(star2);
          } else if (rating > (i-1) && rating < i) {
            temp.push(star1);
          } else if (rating <= (i-1)) {
            temp.push(star0);
          }
        }
      } else {
        temp = [star0, star0, star0, star0, star0];
      }
      return temp;
    }
  }
}
</script>

<style lang="less">
.afm-star-container {
  width: 100%;
  min-height: 12px;
  .star-img-container {
    display: flex;
    height: 10px;
    justify-content: flex-start;
    align-items: center;
    .star-img{
      width: 10px;
      margin-right: 3px;
    }
    .star-text{
      color: #d8d8d8;
      font-size: 12px;
      font-weight: 600;
      font-family: 'Source Sans Pro';
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/afm-star/afm-star.vue